module.exports = __webpack_public_path__ + "static/media/mtech-syllabus.748e48fd.pdf";